import ApiService from './api';
import api from '../hooks/useHttp';

class CarrierService extends ApiService {
  constructor() {
    super('/api/carriers');
  }

  // Get all carriers with pagination and filters
  async getCarriers(params = {}) {
    return await this.get('', params);
  }

  // Get carrier by ID
  async getCarrierById(id) {
    return await this.get(`/${id}`);
  }

  // Search carriers with advanced filters
  async searchCarriers(filters = {}) {
    return await this.get('/search', filters);
  }

  // Get carrier loads
  async getCarrierLoads(id, params = {}) {
    return await this.get(`/${id}/loads`, params);
  }

  // Create new carrier
  async createCarrier(carrierData) {
    return await this.create(carrierData);
  }

  // Update carrier
  async updateCarrier(id, carrierData) {
    return await this.update(id, carrierData);
  }

  // Delete carrier
  async deleteCarrier(id) {
    return await this.delete(id);
  }

  // Delete carrier file (PDF document)
  async deleteCarrierFile(id) {
    return await api.delete(`${this.baseUrl}/${id}/file`);
  }

  // Check if carrier exists by DOT#, MC#, and email (unique identifiers)
  async findCarrierByUniqueFields(dotNumber, mcNumber, email) {
    try {
      const params = {};
      if (dotNumber) params.dotNumber = dotNumber;
      if (mcNumber) params.mcNumber = mcNumber;
      if (email) params.q = email;
      
      const response = await this.searchCarriers(params);
      const apiResponse = response?.data || response;
      const carriers = Array.isArray(apiResponse?.data) ? apiResponse.data : [];
      
      // Find carrier that matches all three unique fields
      const matchingCarrier = carriers.find(carrier => {
        const matchesDot = !dotNumber || (carrier.dotNumber && carrier.dotNumber.toLowerCase().trim() === dotNumber.toLowerCase().trim());
        const matchesMc = !mcNumber || (carrier.mcNumber && carrier.mcNumber.toLowerCase().trim() === mcNumber.toLowerCase().trim());
        const matchesEmail = !email || (carrier.email && carrier.email.toLowerCase().trim() === email.toLowerCase().trim());
        
        return matchesDot && matchesMc && matchesEmail;
      });
      
      return matchingCarrier || null;
    } catch (error) {
      return null;
    }
  }
}

export default new CarrierService();


